module.exports = __webpack_public_path__ + "static/media/asteroids.f3484a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/asteroids.jpg
// module id = 881
// module chunks = 0